import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineHeart } from 'react-icons/hi';
import { ProductContext } from '../context/ProductContext';
import CardComponent from '../component/card';

function Wishlist() {
  const { wishlist } = useContext(ProductContext);

  if (wishlist.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-gray-300 py-20 text-center">
        <HiOutlineHeart size={48} className="text-gray-300" />
        <h2 className="text-xl font-bold text-gray-900">Your wishlist is empty</h2>
        <p className="text-gray-500">Save products you love by tapping the heart icon.</p>
        <Link to="/" className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700">
          Continue shopping
        </Link>
      </div>
    );
  }

  return (
    <div>
      <h2 className="mb-6 text-xl font-bold text-gray-900">Your Wishlist ({wishlist.length})</h2>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {wishlist.map((product) => (
          <CardComponent key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
}

export default Wishlist;
